import { ChartData, ChartSort } from "./chartUtil";

export const imgRender = (files: any, imgUrl: any) => {
    const file = files[0];
    let imgUrls = imgUrl;
    // FileReader 객체 : 웹 애플리케이션이 데이터를 읽고, 저장하게 해줌
    const reader = new FileReader();

    // load 이벤트 핸들러. 리소스 로딩이 완료되면 실행됨.
    reader.onload = (ee: any) => {
        imgUrls = ee.target.result;
    }; // ref previewImage 값 변경

    // 컨텐츠를 특정 file에서 읽어옴. 읽는 행위가 종료되면 loadend 이벤트 트리거함
    // & base64 인코딩된 스트링 데이터가 result 속성에 담김
    reader.readAsDataURL(file);
};

export const numberFormat = (number: number | string) => {
    const formatNum = number.toString();
    return formatNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatDate = (isoDateString: string | number): string => {
    const date = new Date(isoDateString);

    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);

    const formattedDateString = `${year}.${month}.${day} ${hours}:${minutes}`;

    return formattedDateString;
};
export const formatDate2 = (isoDateString: string | number): string => {
    const date = new Date(isoDateString);

    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);

    const formattedDateString = `${year}-${month}-${day}`;

    return formattedDateString;
};
export const dateFormat = (selectDate: number | string | Date) => {
    if (!selectDate) return "";
    let year: string | number = "";
    let month: string | number = "";
    let day: string | number = "";

    if (selectDate instanceof Date) {
        year = selectDate.getFullYear();
        month = String(selectDate.getMonth() + 1).padStart(2, "0");
        day = String(selectDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const str = selectDate.toString();

    if (str.length === 6) {
        try {
            year = parseInt(str.slice(0, 4));
            month = parseInt(str.slice(4, 6));
        } catch (error) {
            year = str.slice(0, 4);
            month = str.slice(4, 6);
        }
        return `${year}년 ${month}월`;
    }

    if (str.length === 8) {
        year = str.slice(0, 4);
        month = str.slice(4, 6);
        day = str.slice(6, 8);
        return `${year}-${month}-${day}`;
    }

    return str;
};

export const chartDateFormat = (date: number | string | Date) => {
    try {
        let year;
        let month;
        let day;
        if (date instanceof Date) {
            year = date.getFullYear();
            month = String(date.getMonth() + 1).padStart(2, "0");
            day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        }

        const strDate = date.toString();

        if (strDate.length === 6) {
            try {
                year = parseInt(strDate.slice(0, 4));
                month = parseInt(strDate.slice(4, 6));
            } catch (error) {
                year = strDate.slice(0, 4);
                month = strDate.slice(4, 6);
            }
            return `${year}년 ${month}월`;
        } else if (strDate.length > 6) {
            try {
                year = parseInt(strDate.slice(0, 4));
                month = parseInt(strDate.slice(4, 6));
                day = parseInt(strDate.slice(6, 8));
            } catch (error) {
                year = strDate.slice(0, 4);
                month = strDate.slice(4, 6);
                day = strDate.slice(6, 8);
            }
            return `${year}년 ${month}월 ${day}일`;
        } else {
            return date as string;
        }
    } catch {
        return date as string;
    }
};
export const chartDateFormat2 = (date: number | string | Date) => {
    let year;
    let month;
    let day;
    if (date instanceof Date) {
        year = date.getFullYear();
        month = String(date.getMonth() + 1).padStart(2, "0");
        day = String(date.getDate()).padStart(2, "0");
        return `${year}.${month}.${day}`;
    }

    const strDate = date.toString();

    if (strDate.length === 6) {
        try {
            year = parseInt(strDate.slice(0, 4));
            month = parseInt(strDate.slice(4, 6));
        } catch (error) {
            year = strDate.slice(0, 4);
            month = strDate.slice(4, 6);
        }
        return `${year}.${month}`;
    } else {
        year = strDate.slice(0, 4);
        month = strDate.slice(4, 6);
        day = strDate.slice(6, 8);
        return `${year}.${month}.${day}`;
    }
};
export const checkImageSrc = (url: string) => {
    return new Promise((resolve) => {
        const img = new Image();

        img.onload = () => resolve(true); // 이미지가 정상적으로 로드된 경우
        img.onerror = () => resolve(false); // 이미지 로드에 실패한 경우

        img.src = url;
    });
};

export const onlyNumInput = (e: Event) => {
    const target = e.target as HTMLInputElement;

    const value = target.value.replace(/[^0-9]/g, "");
    target.value = value;
    return value === "" ? null : Number(value);
};

export const getYearDate = () => {
    const today = new Date();

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    return [oneYearAgo, today];
};

export const setChartData = (
    sort: ChartSort[],
    data: Array<Record<string, number>> | Record<string, number>,
    xAxisKey: string,
    title: string = "",
): ChartData => {
    const dataArray = Array.isArray(data) ? data : [data];
    let isEmpty: boolean = false;

    const xAxis = () => {
        if (xAxisKey) {
            if (Array.isArray(data)) {
                return data.map((value) => chartDateFormat(value[xAxisKey]));
            } else {
                return dataArray.map((value) => chartDateFormat(value[xAxisKey]));
            }
        } else return [""];
    };

    const setValue = (key: ChartSort, idx: number) => {
        const target = dataArray.find((item) => (item && key.valueIdx ? item.idx === key.valueIdx : ""));
        let values = [];
        if (xAxis().length === 1 && dataArray.length > 0) {
            if (target) {
                values = [Number(target?.[key.valueKey] ?? 0)];
            } else {
                if (dataArray.length > 1) {
                    values = [Number(dataArray[idx]?.[key.valueKey] ?? 0)];
                } else {
                    values = [Number(dataArray[0]?.[key.valueKey] ?? 0)];
                }
            }
        } else {
            values = dataArray.map((item) => Number(item?.[key.valueKey] ?? 0));
        }

        return values;
    };

    const chartOption = {
        title,
        data: sort.map((key, idx) => ({
            name: key.name,
            value: setValue(key, idx),
            chartType: key.chartType,
            ...(key.symbol ? { symbol: key.symbol } : {}),
            ...(key.stack ? { stack: key.stack } : {}),
        })),
        xAxis: xAxis(),
        isEmpty: isEmpty as boolean,
    };

    chartOption.isEmpty = chartOption.data.every((i) => i.value.every((v) => v === 0));

    return chartOption;
};

export const setPercentChart = (sort: ChartSort[], data: Array<Record<string, number>> | Record<string, number>): ChartData => {
    const dataArray = Array.isArray(data) ? data : [data];

    return {
        title: "",
        data: sort.map((key) => ({
            name: key.name,
            value: dataArray.map((item) => Number(item[key.valueKey])),
            chartType: key.chartType,
            ...(key.symbol ? { symbol: key.symbol } : {}),
            ...(key.stack ? { stack: key.stack } : {}),
        })),
        xAxis: [...new Set(sort.map((item) => item.stack ?? ""))],
        isEmpty: !data || dataArray.length === 0,
    } as ChartData;
};

export const setWordCloudData = (data: Array<{ keyword: string; cnt: number }>): ChartData => {
    return {
        title: "",
        data: data.map((value) => ({
            name: `${value.keyword}`,
            value: value.cnt,
        })),
        isEmpty: (data && data.length === 0) || !data,
    };
};

export const setCoOccurrenceData = (
    data: { name: string; value: number; color: string }[],
    links: { searchKeyword: string; keyword: string; cnt: number }[],
): ChartData | null => {
    if (data.length == 0) return null;
    const maxCnt = data[0].value;
    const maxVal = 80;
    return {
        title: "",
        data: data.map((item) => ({
            name: `${item.name}`,
            value: item.value,
            symbolSize:
                Math.round((item.value / maxCnt) * 80) + 20 < 50
                    ? 50
                    : Math.round((item.value / maxCnt) * 80) + 20 > maxVal
                      ? maxVal
                      : Math.round((item.value / maxCnt) * 80) + 20,
            itemStyle: {
                color: item.color,
            },
        })),
        links: links
            .filter((item) => item.searchKeyword !== item.keyword)
            .map((item) => {
                return {
                    source: item.keyword,
                    target: item.searchKeyword,
                    value: item.cnt,
                };
            }),
        isEmpty: (data && data.length === 0) || !data,
    };
};

export const errorImg = (event: Event) => {
    const imgElement = event.target as HTMLImageElement;
    return (imgElement.src = require("@/assets/common/NoImg.png"));
};

export const getPercentage = (data: number[]) => {
    // const total = data.reduce((sum, value) => sum + value, 0);

    return data;
};
